import React, { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import * as api from "API/api";

const SelectDate = () => {
  const { bookingData, setBookingData } = useOutletContext();

  const [availableTime, setAvailableTime] = useState([]);

  const date = bookingData?.selectedDate || "";
  const selectedTime = bookingData?.selectedTime || "";

  useEffect(() => {
    if (!date) {
      //setAvailableTime([]);
      setBookingData((prev) => ({
        ...prev,
        selectedDate: "",
        selectedTime: "",
      }));
      return;
    }
    api.getAvailabilities({ date }).then((data) => {
      
      setAvailableTime(data.available_slots || []);
    });
    

    //setAvailableTime(dummySlots);

    // clear time when date changes
    setBookingData((prev) => ({
      ...prev,
      selectedDate: date,
      selectedTime: "",
    }));
  }, [date, setBookingData]);

  return (
    <section className="rounded-2xl bg-white p-6 shadow-sm">
      <h2 className="text-xl font-semibold">Select Date</h2>
      <p className="mt-1 text-sm text-gray-600">
        Choose a date to view available time slots.
      </p>

      <div className="mt-6 grid gap-4 sm:grid-cols-2">
        <div>
          <label className="mb-1 block text-sm font-medium text-gray-700">
            Preferred Date
          </label>
          <input
            type="date"
            className="input border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
            value={date}
            onChange={(e) =>
              setBookingData((prev) => ({
                ...prev,
                selectedDate: e.target.value,
              }))
            }
          />
        </div>

        <div>
          <label className="mb-1 block text-sm font-medium text-gray-700">
            Selected Time
          </label>
          <input
            type="text"
            className="input bg-gray-50 border border-gray-300 rounded-md"
            value={selectedTime}
            placeholder="Pick a slot below"
            readOnly
          />
        </div>
      </div>

      <div className="mt-6">
        <p className="text-sm font-semibold text-gray-900">
          Available Time Slots
        </p>

        {!date ? (
          <div className="mt-3 rounded-xl border border-dashed border-gray-300 bg-gray-50 p-4 text-sm text-gray-600">
            Please select a date to view available time slots.
          </div>
        ) : (
          <div className="mt-3 flex flex-wrap gap-2">
            {availableTime.map((slot) => (
              <button
                key={slot}
                type="button"
                onClick={() =>
                  setBookingData((prev) => ({
                    ...prev,
                    selectedTime: slot,
                  }))
                }
                className={`rounded-full px-4 py-2 text-sm font-semibold border transition ${selectedTime === slot
                  ? "bg-blue-600 text-white border-blue-600"
                  : "bg-white text-gray-900 border-gray-300 hover:bg-gray-50"
                  }`}
              >
                {slot}
              </button>
            ))}
          </div>
        )}
      </div>

      <div className="mt-8 flex justify-between">
        <Link
          to="/appointments/service"
          className="rounded-xl border border-gray-300 bg-white px-6 py-3 text-sm font-semibold text-gray-900 hover:bg-gray-50"
        >
          ← Back
        </Link>

        <Link
          to="/appointments/contactInfo"
          className={`rounded-xl px-6 py-3 text-sm font-semibold text-white ${date && selectedTime
            ? "bg-blue-600 hover:bg-blue-500"
            : "bg-gray-300 cursor-not-allowed pointer-events-none"
            }`}
        >
          Contact Details →
        </Link>
      </div>
    </section>
  );
};

export default SelectDate;
